import { StandardEvents } from '@shopify/events';

const notice = document.querySelector('[data-aog-cart-feedback]');
notice?.querySelector('button')?.addEventListener('click', () => { notice.hidden = true; });
let version = 0;
document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  const current = ++version;
  try {
    const result = await event.promise;
    if (!result || result.detail?.didError) return;
    const cartLink = document.querySelector('[data-aog-cart-link]');
    if (!cartLink) return;
    const response = await fetch(`${cartLink.getAttribute('href')}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    if (current !== version) return;
    document.querySelectorAll('[data-aog-cart-count]').forEach(element => { element.textContent = String(cart.item_count); });
    if (notice && result.detail?.source === 'product-form-component') notice.hidden = false;
  } catch {
    // Native cart errors remain visible in the product form.
  }
});
